"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CURRENCY = exports.giftCards = exports.isGiftCard = exports.getRenderImages = void 0;
var getRenderImages_1 = __importDefault(require("./functions/getRenderImages"));
exports.getRenderImages = getRenderImages_1.default;
var isGiftCard_1 = __importDefault(require("./functions/isGiftCard"));
exports.isGiftCard = isGiftCard_1.default;
var gift_cards_json_1 = __importDefault(require("./data/gift-cards.json"));
var giftCards = gift_cards_json_1.default;
exports.giftCards = giftCards;
var DEFAULT_CURRENCY = 'USD';
exports.DEFAULT_CURRENCY = DEFAULT_CURRENCY;
